import { MixpanelWizardStep } from 'redux/modules/mixpanel/types';
import { Step } from './types';

export const MIXPANEL_WIZARD_STEP_MAP: Record<Step, MixpanelWizardStep> = {
  upload: 'Select Audio',
  'aspect-ratio': 'Choose Aspect Ratio',
  clip: 'Clip Audio',
  submitting: 'loading',
};
